export default "__VITE_ASSET__6b696dbe__"